<template>
    <van-nav-bar class="nav_bar"
                 :style="{top:'env(safe-area-inset-top)',
                 backgroundColor: bColor, color: fColor,
                 borderBottom: border ? (borderStyle ? borderStyle : ''): ''}"
                 @click-left="onClickBack"
                 :border="border"
    >
        <span slot="title" class="title" :style="{color: titleColor}">{{title}}</span>
        <div v-if="showLeft" slot="left" style="display: flex; ">
            <div>
                <van-icon name="arrow-left" style="line-height: 50px" :color="fColor"/>
            </div>

            <div style="line-height: 50px"><span :style="{color: fColor}">{{backText}}</span></div>
        </div>
    </van-nav-bar>
</template>

<script>
    export default {
        name: "Wp_nav_bar",
        props: {
            title: {type: String, defaule: ""},//标题内容
            hasClick: {type: Boolean, defaule: false},//是否需要自定义click方法
            bColor: {type: String, default: "#FFFFFF"},//背景色
            fColor: {type: String, default: "#1989fa"},//左侧文字+图标颜色
            titleColor: {type: String, default: "#555555"},//标题颜色
            border: {type: Boolean, default: false},//是否显示底部边框线
            borderStyle: {type: String, default: ""},//底部边框样式，完整写法：1px solid #999999
            backText: {type: String, default: "返回"},//左侧文字内容
            showLeft: {type: Boolean, default: true},//是否显示左侧返回
        },
        methods: {
            /**
             * 导航返回键
             */
            onClickBack() {
                // this.$log("this.hasClick = " + this.hasClick)
                if (this.hasClick) {
                    this.$emit("click")
                } else {
                    // if(this.$config.project === 'mini' || this.$common.gloabl_wx_openid){
                    //     this.$wx.miniProgram.navigateBack();
                    // }else{
                    //     this.$router.back();
                    // }
                    this.$log("----back-----")
                    this.$router.back();
                    // this.$common.navigateBack();
                    if (this.$config.project === 'mini') {
                        this.$log("----mini back-----")
                        // this.$wx.miniProgram.navigateBack();
                        this.$common.navigateBack();
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .nav_bar {
        position: sticky;
        top: 0;
    }

    .title {
        font-size: 18px;
    }
</style>